import React from "react"
import loginImg from "../assets/images/logo.png"
export function LoginLeft(){
  return (
    <React.Fragment>
      <div className="col-xl-8 col-lg-8 col-sm-12 col-12">
        <div className="d-lg-flex align-items-center justify-content-center p-5">
          <div className="w-50 d-lg-flex align-items-center justify-content-center px-5">
            <img src={loginImg} alt="img" className="w-100" />
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}